import React, { PureComponent } from 'react';
import { ArkResult, FavoritesList, RealtimeAnswer } from '../Components';

class ChatBottom extends PureComponent {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);

        window.recodeSend = this.sttSend.bind(this);
    }

    handleChange(e) {
        const value = e.target.value;

        // 부모(App.js) state 갱신
        this.props.onChangeValue(value);

        // 자동완성(ARK) 사용 시
        if (this.props.useArk) {
            this.props.getArk({
                value,
                isDev: this.props.config.isDev,
                projectId: this.props.config.projectId
            });
        }
    }

    handleKeyPress(e) {
        if (e.charCode === 13) {
            this.send();
        }
    }

    toggleRealtime(value) {
        this.props.toggleRealtimeAnswer(value);
    }

    send() {
        const value = this.props.value;

        if (value && value.trim().length > 0) {
            const sendData = {
                utterance: value,
                sessionKey: this.props.sessionKey,
                channelId: this.props.channelId,
                isLogin: this.props.isLogin,
                isDev: this.props.config.isDev,
                blockId: this.props.responseType === "INPUT" ? this.props.blockId : "",
                blockName: this.props.responseType === "INPUT" ? "INPUT" : "",
                projectId: this.props.config.projectId,
            };

            this.props.send(sendData);
            this.props.onChangeValue('');

        }
    }

    sttSend(e) {
        const value = e.value;

        if (value && value.trim().length > 0) {
            const sendData = {
                utterance: value,
                sessionKey: this.props.sessionKey,
                channelId: this.props.channelId,
                isLogin: this.props.isLogin,
                isDev: this.props.config.isDev,
                blockId: this.props.responseType === "INPUT" ? this.props.blockId : "",
                blockName: this.props.responseType === "INPUT" ? "INPUT" : "",
                projectId: this.props.config.projectId,
            };

            this.props.send(sendData);
        }
    }

    openSTT() {
        try {
            window.requestRecord(); // App에서만 동작
        } catch (error) {
            console.error(error);
        }
    }

    render() {
        let inStyle;
        if (this.props.fromApp) {
            inStyle = { paddingLeft: "30px" };
        }

        return (
            <div className="chat_bottom">
                <div className="chat_bottom_inner">

                    <ArkResult
                        settingArk={this.props.settingArk}
                        useArk={this.props.useArk}
                        data={this.props.arkData}
                        sessionKey={this.props.sessionKey}
                        channelId={this.props.channelId}
                        isLogin={this.props.isLogin}
                        config={this.props.config}
                        send={this.props.send}
                        uiTexts={this.props.uiTexts}
                        toggleRealtimeAnswer={this.props.toggleRealtimeAnswer}
                    />

                    {this.props.showRealtimeAnswer && this.props.realtimeAnswer && (
                        <RealtimeAnswer
                            fromAdvisor={this.props.fromAdvisor}
                            data={this.props.realtimeAnswer}
                            sessionKey={this.props.sessionKey}
                            channelId={this.props.channelId}
                            isLogin={this.props.isLogin}
                            config={this.props.config}
                            send={this.props.send}
                            uiTexts={this.props.uiTexts}
                        />
                    )}

                    {this.props.showFavorites && (
                        <FavoritesList
                            toggleFavorites={this.props.toggleFavorites}
                            setFavorite={this.props.setFavorite}
                            data={this.props.favorite}
                            sessionKey={this.props.sessionKey}
                            channelId={this.props.channelId}
                            isLogin={this.props.isLogin}
                            config={this.props.config}
                            send={this.props.send}
                            uiTexts={this.props.uiTexts}
                        />
                    )}

                    <div className="inp_box" style={inStyle}>
                        <div className="inp_txt">

                            {this.props.fromApp && (
                                <button
                                    type="button"
                                    className="btn_sound"
                                    onClick={() => this.openSTT()}
                                >
                                    <span className="ico_comm ico_mic">음성인식</span>
                                </button>
                            )}

                            <label htmlFor="inquery" className="screen_out">문의내용</label>

                            <input
                                type="text"
                                className="inp"
                                id="inquery"
                                placeholder={this.props.uiTexts.text_08}
                                title="질문입력"
                                autoComplete="off"
                                value={this.props.value}
                                onChange={this.handleChange}
                                onKeyPress={this.handleKeyPress}
                                onFocus={() => this.toggleRealtime(false)}
                            />

                            <button
                                type="button"
                                className="btn_send"
                                id="img_btn"
                                onClick={() => this.send()}
                            >
                                <span className="ico_comm ico_send">문의 내용 전송</span>
                            </button>
                        </div>

                        {this.props.showFavorites ? (
                            <button
                                type="button"
                                className="btn_bookmark is_selected"
                                onClick={() => this.props.toggleFavorites()}
                            >
                                <span className="ico_comm ico_bookmark">즐겨찾는 질문보기</span>
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn_bookmark"
                                onClick={() => this.props.toggleFavorites()}
                            >
                                <span className="ico_comm ico_bookmark">즐겨찾는 질문보기</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default ChatBottom;
